export default {
  post: {
    title: "酒店发布",
    listTitle: "发布",
    addTitle: "添加",
    editTitle: "编辑",
    add: "添加",
    formTitle: "标题",
    formType: "类型",
    formContent: "内容",
    formTitlePlaceholder: " ",
    formContentPlaceholder: " ",
    formTypePlaceholder: " ",
    formPhotos: "添加照片",
    formVideos: "添加视频",
    formPDF: "添加PDF",
    formAgencies: "渠道",
    cancel: "返回",
    save: "保存",
    saveAndPost: "保存并发布",
    toast: {
      postSuccess: "发布成功",
      saveSuccess: "保存成功",
      deleteSuccess: "删除成功"
    },
    channelSelected: "自选渠道",
    channelAll: "所有渠道",
    activityLabel: "公告",
    promotionLabel: "促销",
    exclusiveLabel: "推荐语",
    posted: "发布于",
    foundedIn: "创建于",
    notPost: "未发布"
  }
};
